import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const CompanyContext = createContext(null);
export const useCompany = () => useContext(CompanyContext);

let currentCompanyId = localStorage.getItem("cc_company") || "";
const SKIP = ["/auth", "/companies", "/users", "/notifications", "/search", "/email", "/automations", "/checklists", "/workflow", "/integrations", "/investor", "/units", "/offers", "/documents/", "/operations/", "/invoices/", "/bank/transactions/", "/tasks/"];

api.interceptors.request.use((config) => {
  if (config.method === "get" && currentCompanyId && !SKIP.some((s) => config.url.startsWith(s) && !(s === "/operations/" && config.url === "/operations/"))) {
    config.params = { ...(config.params || {}), company_id: config.params?.company_id ?? currentCompanyId };
  }
  return config;
});

export const CompanyProvider = ({ children }) => {
  const [companyId, setCompanyIdState] = useState(currentCompanyId);
  const [companies, setCompanies] = useState([]);
  const setCompanyId = (id) => { currentCompanyId = id || ""; localStorage.setItem("cc_company", currentCompanyId); setCompanyIdState(currentCompanyId); };
  const loadCompanies = () => api.get("/companies").then((r) => {
    setCompanies(r.data);
    // società selezionata non più esistente (es. demo eliminata) → torna a "Tutte le società"
    if (currentCompanyId && !r.data.some((c) => c.id === currentCompanyId)) setCompanyId("");
  }).catch(() => {});
  useEffect(() => { loadCompanies(); }, []);
  const company = companies.find((c) => c.id === companyId) || null;
  return <CompanyContext.Provider value={{ companyId, setCompanyId, companies, company, loadCompanies }}>{children}</CompanyContext.Provider>;
};
